var styles = {
    container: {
        backgroundColor: '#F9F9FA',
        borderLeft: '1px solid #DDDFE1',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: function (_a) {
            var transitions = _a.transitions;
            return transitions.create(['width', 'padding']);
        },
        position: 'fixed',
        left: 72,
        top: 0,
        height: '100%',
        alignItems: 'flex-start',
        zIndex: 1100,
        px: 2.4,
        py: '20px',
        '> *': {
            width: '100%',
        },
    },
    branding: {
        pt: [2.4, null, 4.8],
        pb: [3, null, 4],
        justifyContent: 'space-between',
        transition: function (_a) {
            var transitions = _a.transitions;
            return transitions.create(['padding']);
        },
    },
    fixedButton: {
        px: 0.8,
        color: 'grey.500',
        cursor: 'pointer',
        translate: 8,
        ':hover': {
            color: 'branding.200',
        },
    },
    logoFull: {
        height: '100%',
        width: 'auto',
        position: 'absolute',
        left: 0,
        top: 0,
    },
    visible: {
        opacity: 1,
    },
    hidden: {
        opacity: 0,
        transition: function (_a) {
            var transitions = _a.transitions;
            return transitions.create('opacity');
        },
    },
    nativeApp: {
        pt: 3.2,
    },
};
export default styles;
